import { useState, useEffect } from 'react';
import raf from 'raf';
import useTransitionListener from './useTransitionListener';

export default function useScrollableHeader({
  headerElement,
  scrollableElement
}) {
  const headerIsTransitioning = useTransitionListener(headerElement);

  const [lastMeasuredY, setLastMeasuredY] = useState(0);
  const [isScrollingDown, setIsScrollingDown] = useState(false);

  useEffect(() => {
    function handleScroll() {
      if (headerIsTransitioning) return;

      const y = scrollableElement
        ? scrollableElement.scrollTop
        : window.scrollY || window.pageOffset;

      raf(function() {
        const isNearTop = y < 100;
        const hasScrolledSufficiently = Math.abs(y - lastMeasuredY) > 20;

        if (isNearTop) {
          setIsScrollingDown(false);
        } else if (hasScrolledSufficiently) {
          setIsScrollingDown(y > lastMeasuredY);
        }

        setLastMeasuredY(y);
      });
    }

    const element = scrollableElement || window;

    element.addEventListener('scroll', handleScroll, { passive: true });

    return function cleanupScrollListener() {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [headerIsTransitioning, lastMeasuredY, scrollableElement]);

  return [isScrollingDown, setIsScrollingDown];
}
